module.exports = __webpack_public_path__ + "assets/icons/junk.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/jobcategories/junk.png
// module id = ./src/styles/icons/jobcategories/junk.png
// module chunks = 0